// extracted by mini-css-extract-plugin
export var chip = "_cy-0";
export var filterDropdown = "_cy-5";
export var filterItem = "_cy-6";
export var icon = "_cy-1";
export var removeButton = "_cy-3";
export var removeIcon = "_cy-4";
export var separator = "_cy-2";